const nav = {
    'nav.dashboard': 'Dashboard',
    'nav.profiles': 'Profielen',

    'nav.profile': 'Mijn profiel',

    'nav.ghost.return_to_reseller': 'Terugkeren naar reseller',
    'nav.ghost.return_to_admin': 'Terugkeren naar beheerder',

    'nav.footer.about': 'Over Speedcon B.V.',
    'nav.footer.conditions': 'Voorwaarden',
    'nav.footer.help': 'Help',
    'nav.footer.contact': 'Contact',
    'nav.footer.logged_in': 'Je bent nu ingelogd als',
};

export default nav;
